var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockParagraphWithImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.948,
    height: 28.948,
    viewBox: "0 0 28.948 28.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.33,0H3.619A3.623,3.623,0,0,0,0,3.619V25.33a3.623,3.623,0,0,0,3.619,3.619H25.33a3.623,3.623,0,0,0,3.619-3.619V3.619A3.623,3.623,0,0,0,25.33,0Zm1.206,25.33a1.207,1.207,0,0,1-1.206,1.206H3.619A1.207,1.207,0,0,1,2.412,25.33V3.619A1.207,1.207,0,0,1,3.619,2.412H25.33a1.207,1.207,0,0,1,1.206,1.206Z",
    fill: "#555"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.078,
    height: 19.387,
    rx: 1,
    transform: "translate(4.781 4.781)",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1V18.387H7.078V1H1M1,0H7.078a1,1,0,0,1,1,1V18.387a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    transform: "translate(4.781 4.781)",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,1.15H0A1.15,1.15,0,0,1-1.15,0,1.15,1.15,0,0,1,0-1.15H5A1.15,1.15,0,0,1,6.151,0,1.15,1.15,0,0,1,5,1.15Z",
    transform: "translate(17.475 5.931)",
    fill: "#555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5,1.15H0A1.15,1.15,0,0,1-1.15,0,1.15,1.15,0,0,1,0-1.15H5A1.15,1.15,0,0,1,6.151,0,1.15,1.15,0,0,1,5,1.15Z",
    transform: "translate(17.475 9.956)",
    fill: "#555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5,1.15H0A1.15,1.15,0,0,1-1.15,0,1.15,1.15,0,0,1,0-1.15H5A1.15,1.15,0,0,1,6.151,0,1.15,1.15,0,0,1,5,1.15Z",
    transform: "translate(17.475 14.474)",
    fill: "#555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5,1.15H0A1.15,1.15,0,0,1-1.15,0,1.15,1.15,0,0,1,0-1.15H5A1.15,1.15,0,0,1,6.151,0,1.15,1.15,0,0,1,5,1.15Z",
    transform: "translate(17.475 18.997)",
    fill: "#555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5,1.15H0A1.15,1.15,0,0,1-1.15,0,1.15,1.15,0,0,1,0-1.15H5A1.15,1.15,0,0,1,6.151,0,1.15,1.15,0,0,1,5,1.15Z",
    transform: "translate(17.475 23.018)",
    fill: "#555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockParagraphWithImage);
export default __webpack_public_path__ + "static/media/block_paragraph_with_image.a841c89baca9d13fb6303d7fe489a42f.svg";
export { ForwardRef as ReactComponent };